import { render } from "./EditPlacePage.vue?vue&type=template&id=12bd61f2&ts=true"
import script from "./EditPlacePage.vue?vue&type=script&lang=ts"
export * from "./EditPlacePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__